
export class Latlong {
    public latitude: number =  0.0;
    public longitude: number = 0.0;
}
